import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { videos } from "@/mocks/videos";

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 py-10 md:px-8 md:py-14">
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            分类快捷入口
          </h2>
          <p className="mt-1 text-sm text-foreground-600">按兴趣直达，找到你想看的内容</p>
        </div>
      </div>

      <div className="-mx-4 flex gap-3 overflow-x-auto px-4 pb-2 md:mx-0 md:grid md:grid-cols-3 md:gap-4 md:overflow-visible md:px-0 lg:grid-cols-6">
        {categories.map((cat) => {
          const count = videos.filter((v) => v.categoryId === cat.id).length;
          return (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group flex w-40 shrink-0 flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-300 md:w-auto"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-2xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={cat.icon} />
              </span>
              <span className="mt-3 text-sm font-semibold text-foreground-900">{cat.name}</span>
              <span className="mt-1 line-clamp-2 text-xs leading-5 text-foreground-600">{cat.description}</span>
              <span className="mt-3 text-xs font-medium text-accent-600">{count} 个视频</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}